<template>
  <div class="ml10">
    <div v-for="linesData in data.linesData">
      <div v-for="lines in linesData">
        <p v-html="changeTag(lines.text)" class="bold" />
        <div v-for="child in lines.lineChildren"  class="mb10">
          <p v-html="changeTag(child.childText)" />
          <p v-html="changeTag(child.examples.example)" class="ml20" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/mixin/common';

export default {
  name: 'setPhraseResult',
  props: {
    data: Object
  },
  mixins: [
    common
  ]
};
</script>

<style lang="scss">
@import 'src/assets/style/modal';
</style>



// WEBPACK FOOTER //
// SetPhraseResult.vue?026b12f9